import React from "react";
import './Dedicated.scss';

const CaseComponent = ({ data }) => {
  const { title, description, img, imgMin } = data;
  return (
    <div className="dedicated-case">
      <div className="case-img-container">
        <img src={img} alt="web development icon" />
      </div>
      <div className="case-text">
        <h3 className="case-title">{title}</h3>
        <div className="case-description">{description}</div>
      </div>
    </div>
  );
};

export default function Dedicated({ data }) {
  const { title, description, cases } = data;
  return (
    <section className="dedicated-wrapper">
      <div className="dedicated-text">
        <h2 className="dedicated-title">{title}</h2>
        <div className="dedicated-description">{description}</div>
      </div>
      <div className="dedicated-cases">
        {cases.map((caseData) => <CaseComponent data={caseData} />)}
      </div>
    </section>
  );
};
